import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=fd9d3c50&"
import script from "./SideMenu.vue?vue&type=script&lang=ts&"
export * from "./SideMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports